import React from 'react';
import PropTypes from 'prop-types';
import useApp from 'reducers/hooks/useApp';

import useFirebaseChat from 'reducers/hooks/firebase/useChat';
import Menu from './components/Menu';

import useStyles from './useStyles';

const AppLayout = props => {
  const { children } = props;
  const classes = useStyles();
  const { isOnline } = useFirebaseChat();
  const { currentUser } = useApp();

  return (
    <div className={classes.paper}>
      <Menu currentUser={currentUser} isOnline={isOnline} />
      <main className={classes.content}>{children}</main>
    </div>
  );
};

AppLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppLayout;



// WEBPACK FOOTER //
// ./src/layouts/AppLayout/AppLayout.js